import { Link } from 'react-router-dom';

const footerLinks = {
  quickLinks: [
    { path: '/', label: '首页' },
    { path: '/about', label: '关于我们' },
    { path: '/category/all', label: '漫画分类' },
  ],
  categories: [
    { path: '/category/all', label: '恋爱漫画' },
    { path: '/category/all', label: '动作漫画' },
    { path: '/category/all', label: '奇幻漫画' },
    { path: '/category/all', label: '悬疑漫画' },
  ],
  social: [
    { icon: 'ri-wechat-line', label: '微信' },
    { icon: 'ri-weibo-line', label: '微博' },
    { icon: 'ri-bilibili-line', label: 'B站' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 py-12 md:py-16">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-accent-400"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                韩漫大全
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              韩漫大全免费平台是韩国漫画在线阅读网标杆，每日更新最新章节，提供海量<strong>韩漫资源</strong>，支持评论与收藏功能，让您随时随地畅享韩漫阅读乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-400 mb-5">
              快速链接
            </h4>
            <ul className="space-y-3">
              {footerLinks.quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-200 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-400 mb-5">
              漫画分类
            </h4>
            <ul className="space-y-3">
              {footerLinks.categories.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-200 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-400 mb-5">
              关注我们
            </h4>
            <div className="flex gap-4 mb-6">
              {footerLinks.social.map((social) => (
                <a
                  key={social.label}
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-800 hover:bg-primary-700 text-background-200 hover:text-accent-400 transition-colors cursor-pointer"
                  aria-label={social.label}
                  rel="nofollow"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
            <p className="text-xs text-background-400">
              联系邮箱：hello@knn08.com
            </p>
          </div>
        </div>

        <div className="relative py-8 border-t border-primary-800/50 overflow-hidden">
          <h2 className="text-[12vw] md:text-[10vw] font-heading font-black text-primary-800/30 leading-none tracking-tighter select-none whitespace-nowrap">
            韩漫大全
          </h2>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mt-6 gap-3">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} 韩漫大全 HanManDaQuan. 版权所有。
            </p>
            <div className="flex items-center gap-4 text-xs text-background-400">
              <a href="#" className="hover:text-accent-400 transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="hover:text-accent-400 transition-colors" rel="nofollow">服务条款</a>
              <a href="#" className="hover:text-accent-400 transition-colors" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}